import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {Table, TableModule} from 'primeng/table';
import {DateTime} from 'luxon'
import {DecimalPipe, NgIf} from "@angular/common";
import {TooltipModule} from "primeng/tooltip";
import {CookieService} from "@/app/services/cookie.service";
import {EventNode} from "@/app/model/interface/event-node";
import {getTzAbbrOrFallback} from "@/app/common/common";

@Component({
    selector: 'app-schedule-table',
    templateUrl: './schedule-table.component.html',
    imports: [
        TableModule,
        TooltipModule,
        DecimalPipe,
        NgIf,
        TranslatePipe
    ],
    styleUrls: ['./schedule-table.component.scss']
})
export class ScheduleTableComponent implements OnInit {

    @Input() nodes: EventNode[];

    @Input() scheduleStatuses: any[] = [];
    @ViewChild('dt1', {static: false}) nodesTable: Table;
    frozenColumns = [];
    tooltipOptions = {autoHide: false, hideOnEscape: false, escape: false, hideDelay: 1000000000000000000};
    locale: string;

    constructor(private translate: TranslateService, private cookieService: CookieService) {
    }

    ngOnInit(): void {
        this.locale = this.cookieService.getI18NLocale() || 'en-us';
    }

    getScheduleStatusLabel(status: any) {
        switch (status) {
            case 'COMPLETED':
            case 'OVERLAPPING':
                return this.translate.instant("DISPATCH_SCHEDULE.SCHEDULE_STATUS.COMPLETED");
            case 'ONGOING':
                return this.translate.instant("DISPATCH_SCHEDULE.SCHEDULE_STATUS.ONGOING");
            case 'UPCOMING':
                return this.translate.instant("DISPATCH_SCHEDULE.SCHEDULE_STATUS.UPCOMING");
            case 'STANDBY':
                return this.translate.instant("DISPATCH_SCHEDULE.SCHEDULE_STATUS.STANDBY");
        }
    }

    getLocalTime(dttm: any, timezone: any) {
        if (!!dttm) {
            const localDate = DateTime.fromISO(dttm).setZone(timezone);
            return localDate.setLocale(this.locale).toLocaleString(DateTime.DATETIME_MED) + ' ' + getTzAbbrOrFallback(timezone, localDate.toJSDate(), localDate.setLocale('en-us').toFormat('ZZZZ'));
        } else {
            return this.translate.instant("DISPATCH_LIST.PORTFOLIO_CARD.WINDOW.NONE");
        }
    }

}
